/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { toEmojiHtml } from '../common/community/feed/preview-html';

// Plain text as HTML with emojione images, for titles bound with [innerHTML].
@Pipe({
  name: 'emojiHtml',
  standalone: true,
})
export class EmojiHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return toEmojiHtml(value ?? '');
  }
}
